<template>
  <div class="white" style="width: 100%">
    <v-snackbar
      v-bind:class="
        $vuetify.breakpoint.xsOnly ? 'alert-bottom-margin' : 'alert-top-margin'
      "
      v-model="active"
      :value="active"
      :color="alert.color"
      :bottom="$vuetify.breakpoint.xsOnly"
      :top="!$vuetify.breakpoint.xsOnly"
      :timeout="5000"
    >
      <v-row align="center" class="ma-0 pa-0">
        <v-col v-if="icon" cols="1" class="ma-0 pa-0 pr-2">
          <v-icon color="white">{{ icon }}</v-icon>
        </v-col>
        <v-col :cols="!!icon ? 11 : 12" class="pl-4 ma-0 pa-0">{{
          alert.text
        }}</v-col>
      </v-row>
    </v-snackbar>
  </div>
</template>

<style>
.alert-top-margin {
  margin-top: constant(safe-area-inset-top) !important;
  margin-top: env(safe-area-inset-top) !important;
}
.alert-bottom-margin {
  padding-bottom: 70px !important;
}
</style>

<script>
import { mapGetters, mapMutations } from "vuex";
import { mdiCheckCircleOutline, mdiAlertCircleOutline } from "@mdi/js";
export default {
  data() {
    return {
      icons: {
        success: mdiCheckCircleOutline,
        error: mdiAlertCircleOutline,
      },
    };
  },
  methods: {
    ...mapMutations("general", ["setAlert"]),
  },
  computed: {
    ...mapGetters("general", ["alert"]),
    active: {
      get() {
        return this.alert.active;
      },
      set() {
        this.setAlert({
          active: false,
          color: "",
          text: "",
          icon: "",
        });
      },
    },
    icon() {
      return this.icons[this.alert.color] || this.alert.icon;
    },
  },
};
</script>